var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.17141 11.1045H25.8652C26.1662 11.1045 26.4548 11.2297 26.6676 11.4527C26.8804 11.6756 26.9999 11.9779 26.9999 12.2932C26.9999 12.6085 26.8804 12.9108 26.6676 13.1338C26.4548 13.3567 26.1662 13.4819 25.8652 13.4819H3.17141C2.87047 13.4819 2.58186 13.3567 2.36906 13.1338C2.15626 12.9108 2.03672 12.6085 2.03672 12.2932C2.03672 11.9779 2.15626 11.6756 2.36906 11.4527C2.58186 11.2297 2.87047 11.1045 3.17141 11.1045Z",
    fill: "#FFF4D9",
    stroke: "#FFF4D9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87091 12.2929L13.7275 21.6558C13.9506 21.8678 14.076 22.1553 14.076 22.4552C14.076 22.755 13.9506 23.0426 13.7275 23.2546C13.5043 23.4666 13.2016 23.5858 12.8861 23.5858C12.5705 23.5858 12.2678 23.4666 12.0447 23.2546L1.34914 13.0923C1.23846 12.9874 1.15066 12.8628 1.09075 12.7256C1.03084 12.5885 1 12.4414 1 12.2929C1 12.1444 1.03084 11.9973 1.09075 11.8601C1.15066 11.7229 1.23846 11.5983 1.34914 11.4934L12.0447 1.33114C12.2678 1.11911 12.5705 1 12.8861 1C13.2016 1 13.5043 1.11911 13.7275 1.33114C13.9506 1.54316 14.076 1.83073 14.076 2.13057C14.076 2.43042 13.9506 2.71798 13.7275 2.93001L3.87091 12.2929Z",
    fill: "#FFF4D9",
    stroke: "#FFF4D9",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowLight);
export default __webpack_public_path__ + "static/media/backArrowLight.79fa2767763d94921b254f167e9c5f5c.svg";
export { ForwardRef as ReactComponent };